// extracted by mini-css-extract-plugin
export var button = "_a7-4";
export var hasDarkBackground = "_a7-7";
export var hasLightBackground = "_a7-6";
export var iconWrapper = "_a7-0";
export var large = "_a7-2";
export var medium = "_a7-1";
export var small = "_a7-5";
export var xsmall = "_a7-3";